import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const ExamityReview = observer(class ExamityReview extends React.Component {
  componentWillMount() {
    const { SessionStore, StepInStore } = this.props.store;
    const { examSid, sessionSid } = this.props;

    if(SessionStore.loadingCalls.indexOf('getReviewUrl') < 0) {
      StepInStore.getReviewUrl(examSid, sessionSid);
    }
  }

  render() {
    const { translation } = this.props;
    const { SessionStore, StepInStore } = this.props.store;

    if(SessionStore.backgroundLoadingCalls.indexOf('getReviewUrl') < 0) {
      return (
        <article className="frame-wrap">
          <header className="frame-wrap__head">
            <a
              className="btn btn--inverse btn--icn-right"
              target="_blank"
              href={StepInStore.reviewUrl}
            >
              {translation.pop_out}
              <icons.iconExternal />
            </a>
          </header>

          <iframe
            className="review-frame"
            src={StepInStore.reviewUrl}
          ></iframe>
        </article>
      )
    }

    return null;
  }
})

export default translate('ExamityReview')(ExamityReview);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/ExamityReview.js